import { EntityTypeEnum, PermissionEnum } from '@sr-sdks/api-sdk-axios';
import { Alert, type AlertProps } from '@sr/ui-library';
import { useNavigate } from 'react-router-dom';
import { useActiveWorkspace } from '../../../hooks/useActiveWorkspace';
import { useCurrentUserAuth } from '../../../hooks/useCurrentUserAuth';

/**
 * Shows ABN verification alert only for the currently selected workspace.
 */
export const AlertForUnverifiedBusinessNumber = ({ ...props }: AlertProps) => {
  const navigate = useNavigate();
  const { auth } = useCurrentUserAuth();
  const [activeWorkspace] = useActiveWorkspace();

  const canEditWorkspaceDetails = auth?.currentUserHasPermission(
    PermissionEnum.EditWorkspaceDetails,
  );

  const shouldShowAlert =
    canEditWorkspaceDetails &&
    !!activeWorkspace?._id &&
    !activeWorkspace.businessNumberVerified &&
    activeWorkspace.businessNumberCountry === 'AU' &&
    activeWorkspace.entityType === EntityTypeEnum.Company;

  if (!shouldShowAlert) return null;

  return (
    <Alert
      actionButtonProps={{
        children: 'Verify',
        onClick: () =>
          navigate(
            `/workspace/${activeWorkspace._id}/manage-workspace/details`,
          ),
      }}
      hasActionButton
      {...props}
    >
      The ABN on your workspace <strong>{activeWorkspace.workspaceName}</strong>{' '}
      cannot be verified. Please check your business details so that we can
      continue to process your payments. If you require further assistance,
      contact support@screenrights.org.
    </Alert>
  );
};
